


export const config =  {
    PROD_BASE_URL : 'https://iandiapi.onrender.com/api' 
}